import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 5L7 9L11 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronDown;
